import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Grid, Stack } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { SelectBox } from '../components/FormComponents';
import useStyles from '../hooks/useStyles';
import styles from '../layouts/pages/style';
import GeographyCountryCard from '../sections/@dashboard/geography/GeographyCountryCard';
import { PackageHeader } from '../components/CustomHeading';
import { getAccCountByCountryLang, getCountryKpiScore, getPackageList } from '../features';
import Metatags from '../components/MetaTags/MetaTags';
import GeoMap from '../modules/Geography/GeoMap';
import GeoKpiScore from '../modules/Geography/GeoKpiScore';

export default function GeographiesPage() {
  const dispatch = useDispatch();
  const classes = useStyles(styles)();

  const [selectedPackage, setSelectedPackage] = useState('');
  const [refreshGeography, setRefreshGeography] = useState(false);
  const [refreshGeoKpiScore, setRefreshGeoKpiScore] = useState(false);
  const [country, setCountry] = useState('');

  const {
    accCountByCountry = [], loading, error,
  } = useSelector((state) => state.accCountByCountryLang);
  const {
    versionData, loading: versionDataLoading, error: versionDataError,
  } = useSelector((state) => state.countryKpiScore);
  const packageListData = useSelector((state) => state.packageList?.packageMenuList);

  useEffect(() => {
    dispatch(getPackageList());
  }, []);

  const packageList = useMemo(() => {
    return packageListData
      ?.filter((item) => item.isEnabled !== false)
      .map((item) => ({
        id: item.packageId,
        name: item.packageLabel,
        value: item.packageId,
      }));
  }, [packageListData]);

  useEffect(() => {
    if (packageList?.[0]?.value) {
      setSelectedPackage(packageList[0].value);
    }
  }, [packageList]);

  useEffect(() => {
    if (selectedPackage) {
      dispatch(getAccCountByCountryLang({ packageId: selectedPackage }));
    }
  }, [refreshGeography, selectedPackage]);

  useEffect(() => {
    if (selectedPackage) {
      dispatch(getCountryKpiScore({ pkgId: selectedPackage }));
    }
  }, [refreshGeoKpiScore, selectedPackage]);

  return (
    <>
      <Metatags metaTagName="Geographies | ISV Insights" />
      <Container maxWidth="xl">
        <Grid container gap={2}>
          <Grid item xs={12} className={classes.cardStyles}>
            <Stack className={classes.headerStyles}>
              <PackageHeader noPackage heading="Geography" />
              <SelectBox
                title="Package"
                height="35px"
                width="200px"
                value={selectedPackage}
                data={packageList}
                onChange={(e) => setSelectedPackage(e.target.value)}
              />
            </Stack>
          </Grid>

          <Grid container item xs={12} justifyContent="space-between" spacing={2}>
            <Grid item xs={12} md={4} lg={3}>
              <GeographyCountryCard
                headerIcon={<LanguageIcon />}
                title="Countries"
                cardHeadTitle="COUNTRY"
                whichList="Countries"
                refresh={setRefreshGeography}
                loading={loading}
                error={error}
                data={accCountByCountry}
                setCountry={setCountry}
              />
            </Grid>
            <Grid item xs={12} md={8} lg={9}>
              <GeoMap country={country} setCountry={setCountry} data={accCountByCountry} />
            </Grid>
          </Grid>
          <Grid item xs={12} justifyContent="space-between" spacing={2} className={classes.cardStyles}>
            <GeoKpiScore
              refresh={setRefreshGeoKpiScore}
              loading={versionDataLoading}
              error={versionDataError}
              data={versionData}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
